module.exports = __webpack_public_path__ + "img/header_bg2.80f916d8.jpg";